import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'currency',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'currency',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'currency',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'currency',
  action: ActionType.UPDATE,
};

export const Currency = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
